const riot = require('riot');

riot.tag2('modal-csv-preview', '<div class="modal f fclm w760 py20 elevation-default-mid bg-white rounded-4" ref="modal"> <div class="px32 mb20"> <div class="ts-hm text-navy mb20">{getText().title}</div> <div class="ts-pm white-space-pre-wrap">{getText().description}</div> </div> <div class="h220 mb20" data-is="module-table" schemas="{tableSchemas}" items="{opts.items}"></div> <div class="px32 mb20" if="{!opts.isRaffle}"> <div class="ts-ps text-red_70" each="{text in cautionTexts}">{text}</div> </div> <div class="f fr px20"> <button class="button text mr12" onclick="{close}">キャンセル</button> <button class="button primary" onclick="{submit}">インポート</button> </div> </div>', 'modal-csv-preview .modal,[data-is="modal-csv-preview"] .modal{max-width:80vw}', 'class="f fh s-full px16 bg-modal_overlay" spat-animation="fade"', function(opts) {
    this.cautionTexts = [
      '・「インポート」を押すとポイント購入可能残高が消費されます',
      '・一度Reproのインセンティブコードリストにインポートした後は、他の施策に利用することができません',
    ];

    this.on('mount', () => {
      var table_schemas = [
        {
          id: 'conversion_at',
          label: 'conversion_at',
          class: 'w136 flex-fixed',
          getText: (v) => dayjs(v).format('YYYY-MM-DD'),
        },
        {
          id: 'service_uid',
          label: 'service_uid',
          class: 'min-width-228 flex-auto',
        },
      ];

      if (!this.opts.isRaffle) {

        if (!this.opts.pointProviderSelectionEnabled) {
          table_schemas.push(
            {
              id: 'point_provider',
              label: 'point_provider',
              class: 'w228 flex-fixed',
            }
          );
        }
        table_schemas.push(
          {
            id: 'distribution_point_amount',
            label: 'point_amount',
            class: 'w104 flex-fixed',
            align: 'right',
            getText: (v) => v.toLocaleString(),
          }
        );
      }

      var option_table_schemas = [
        {
          id: 'option_email',
          label: 'option_email',
          class: 'w136 flex-fixed',
        },
      ];

      if (this.opts.headers) {

        var options = this.opts.headers.filter(h => !h.indexOf('option_'));
        if (options.length) {
          options.forEach(option => {
            var add_option = option_table_schemas.find(schema => schema.id === option);
            if (add_option) {
              table_schemas.push(add_option);
            }
          });
        }
        this.tableSchemas = this.opts.headers.map(header => {
          return table_schemas.find(schema => schema.id === header)
        });
      }
      else {
        this.tableSchemas = table_schemas;
      }
      this.update();
    });

    this.submit = () => {
      this.value = true;
      this.close();
    };

    this.getText = () => {
      if (this.opts.isCreateEvent) {
        return {
          title: 'この内容で発行しますか？',
          description: `発行数: ${this.opts.count} 件${this.opts.isRaffle ? "" : `\n付与ポイント額: ${this.opts.amount}円\n合計金額: ${this.opts.count * this.opts.amount} 円`}`,
        }
      }
      return {
        title: 'CSVをインポートしますか？',
        description: '投稿前に再度ファイルのフォーマットが正しいか確認して下さい。\n実行するとOne Time URLが自動発行されます。',
      };
    };
});